/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my text uploaded anywhere?`)
};

const es_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se carga mi texto en algún lugar?`)
};

const de_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Text irgendwo hochgeladen?`)
};

const nl_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn tekst ergens geüpload?`)
};

const fr_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon texte est-il téléchargé quelque part ?`)
};

const it_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio testo viene caricato da qualche parte?`)
};

const pt_br2_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é carregado em algum lugar?`)
};

const pt_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu texto é enviado para algum lugar?`)
};

const ja_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私のテキストはどこかにアップロードされていますか？`)
};

const zh_cc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的文本会被上传到什么地方吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq2_q", locale)
	if (locale === "en") return en_cc_faq2_q(inputs)
	if (locale === "es") return es_cc_faq2_q(inputs)
	if (locale === "de") return de_cc_faq2_q(inputs)
	if (locale === "nl") return nl_cc_faq2_q(inputs)
	if (locale === "fr") return fr_cc_faq2_q(inputs)
	if (locale === "it") return it_cc_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq2_q(inputs)
	if (locale === "pt") return pt_cc_faq2_q(inputs)
	if (locale === "ja") return ja_cc_faq2_q(inputs)
	return zh_cc_faq2_q(inputs)
};